import React, { useMemo } from 'react';
import { usePermissions } from '@src/hooks';
import {
    EffectivePermissions,
    PermissionRole,
} from '@src/services/users/myPermissions/myPermissionsApiSliceTypes';

type PermissionGuardProps = {
    module: keyof EffectivePermissions;
    allowedRoles?: PermissionRole[];
    children: React.ReactNode;
    fallback?: React.ReactNode;
};

const defaultModuleRoles: Record<keyof EffectivePermissions, PermissionRole[]> =
    {
        Dashboard: ['admin', 'viewer'],
        Sims: ['admin', 'viewer'],
        'Plan_Management.Plans': ['admin', 'viewer'],
        'Plan_Management.Zones': ['admin', 'viewer'],
        SubAccounts: ['admin', 'viewer'],
        UserManagement: ['admin', 'viewer'],
        RoleManagement: ['admin', 'viewer'],
        ActivityLogManagement: ['admin', 'viewer'],
        Countries: ['admin', 'viewer'],
        Operators: ['admin', 'viewer'],
        'B2CManagement.Users': ['admin', 'viewer'],
        'B2CManagement.Packages': ['admin', 'viewer'],
        'B2CManagement.Discounts': ['admin', 'viewer'],
        'B2CManagement.Sales': ['admin', 'viewer'],
    };

export const PermissionGuard = ({
    module,
    allowedRoles,
    children,
    fallback = null,
}: PermissionGuardProps) => {
    const { permissionOf } = usePermissions();
    const role = permissionOf(module);

    const rolesToCheck = allowedRoles ??
        defaultModuleRoles[module] ?? ['admin'];

    const isAllowed = useMemo(
        () => role !== undefined && rolesToCheck.includes(role),
        [role, rolesToCheck]
    );

    if (!isAllowed) return <>{fallback}</>;

    return <>{children}</>;
};
